import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";

import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "./api";

import { Per_Page_Dropdown, Select2Data, RegxExpression } from "./common";

export const Context = createContext();

const AppContext = ({ children }) => {
  // const IMG_URL = "http://192.168.16.183:8456";
  // const IMG_URL = "http://127.0.0.1:1515";
  const IMG_URL = "https://myflowereventnode.profcymadev.com:1519";
  // const IMG_URL = "https://node.localmandai.com:3030";

  // const IMG_URL = "https://localmandai.node.profcymadev.com:8456";

  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [variant, setVariant] = useState("");
  const [userdata, setUserData] = useState({});
  const [isAllow, setisAllow] = useState([]);
  const [wishlistData, setWishlistData] = useState([]);
  const [addCartModal, setAddCartModal] = useState(false);
  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [signinGoogle, setSigninGoogle] = useState(false);
  const [cartData, setCartData] = useState([]);
  const [cartStatus, setCartStatus] = useState(false);
  const minLength = 2;

  const maxLength = 30;

  const [taxRupees, setTaxRupees] = useState("");

  const [reactLoader, setReactLoader] = useState(false);

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const [cartCount, setCartCount] = useState(0);
  const [countNotification, setCountNotification] = useState(0);
  const [currentLocation, setCurrentLocation] = useState(false);
  const [trigger, setTrigger] = useState(0);

  const triggerCartUpdate = () => {
    setTrigger(trigger === 0 ? 1 : 0);
  };

  const getuserData = async (id) => {
    const response = await getData(`/auth/user-get`);
    await setUserData(response?.data);
  };

  const updateCartCount = async () => {
    if (signin) {
      try {
        const cartItems = await getData(`/cart/show`);
        setCartCount(cartItems?.data?.length || 0);
      } catch (error) {
        console.log(error);
      }
    } else if (Cookies.get("local_mandai_cart")) {
      setCartCount(JSON.parse(Cookies.get("local_mandai_cart")).length);
    }
  };

  const updateWishliStCount = async () => {
    if (signin) {
      try {
        const cartItems = await getData(`/cart/show`);
        setCartCount(cartItems?.data?.length || 0);
      } catch (error) {
        console.log(error);
      }
    } else if (Cookies.get("local_mandai_cart")) {
      setCartCount(JSON.parse(Cookies.get("local_mandai_cart")).length);
    }
  };

  useEffect(() => {
    updateCartCount();
  }, [Cookies.get("local_mandai_cart"), signin, trigger, addCartModal]);

  const isTokenValid = async () => {
    const token = Cookies.get("hindustan_solar_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("hindustan_solar_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
      } else {
        setisAllow(decodedToken?.permissions);
        getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);

        setSignin(true);
      }
    } else {
      setisAllow([]);
      setSignin(false);
      setUsertype("");
      // navigate("/");
    }
  };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const user = urlParams.get("user");

    if (token && user) {
      Cookies.set("hindustan_solar_security", token, {
        expires: 1,
      });
      setSignin(true);

      console.log("User:", user);
    } else {
      console.log("Login failed or missing token");
    }
  }, [signinGoogle]);

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  return (
    <Context.Provider
      value={{
        IMG_URL,
        getData,
        postData,
        putData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        variant,
        setVariant,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        Select2Data,
        Per_Page_Dropdown,
        RegxExpression,
        shimmerLoader,
        setShimmerLoader,
        addCartModal,
        setAddCartModal,
        cartCount,
        triggerCartUpdate,
        wishlistData,
        setWishlistData,
        updateCartCount,
        setSigninGoogle,
        signinGoogle,
        getuserData,
        taxRupees,
        setTaxRupees,
        reactLoader,
        setReactLoader,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
